import { c as _c } from "react/compiler-runtime";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import type { CreateWaveDisplayConfig, WaveOverviewConfig } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveDisplaySettings from "./CreateWaveDisplaySettings";
import CreateWaveImageInput from "./CreateWaveImageInput";
import CreateWaveNameInput from "./CreateWaveNameInput";
import CreateWaveType from "./type/CreateWaveType";
const DEFAULT_DISPLAY: CreateWaveDisplayConfig = {
  approve: {
    approvalsTabLabel: "",
    approvedTabLabel: ""
  }
};
export default function CreateWaveOverview(t0) {
  const $ = _c(28);
  const {
    overview,
    display: t1,
    errors,
    setOverview,
    setDisplay: t2
  } = t0;
  const display = t1 === undefined ? DEFAULT_DISPLAY : t1;
  const setDisplay = t2 === undefined ? _temp : t2;
  let t3;
  if ($[0] !== overview || $[1] !== setOverview) {
    t3 = t4 => {
      const {
        key,
        value
      } = t4;
      return setOverview({
        ...overview,
        [key]: value
      });
    };
    $[0] = overview;
    $[1] = setOverview;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const onChange = t3;
  let t4;
  if ($[3] !== errors || $[4] !== onChange || $[5] !== overview.name) {
    t4 = <CreateWaveNameInput onChange={onChange} name={overview.name} errors={errors} />;
    $[3] = errors;
    $[4] = onChange;
    $[5] = overview.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-iron-200">Wave Profile Picture</p>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onChange) {
    t6 = file => onChange({
      key: "image",
      value: file
    });
    $[8] = onChange;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== overview.image || $[11] !== t6) {
    t7 = <div className="tw-space-y-3">{t5}<CreateWaveImageInput imageToShow={overview.image} setFile={t6} /></div>;
    $[10] = overview.image;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onChange) {
    t8 = type => onChange({
      key: "type",
      value: type
    });
    $[13] = onChange;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== overview.type || $[16] !== t8) {
    t9 = <CreateWaveType selected={overview.type} onChange={t8} />;
    $[15] = overview.type;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== display || $[19] !== errors || $[20] !== overview.type || $[21] !== setDisplay) {
    t10 = overview.type === ApiWaveType.Approve ? <CreateWaveDisplaySettings display={display.approve} errors={errors} onChange={approve => setDisplay({
      ...display,
      approve
    })} /> : null;
    $[18] = display;
    $[19] = errors;
    $[20] = overview.type;
    $[21] = setDisplay;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t4 || $[25] !== t7 || $[26] !== t9) {
    t11 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t4}{t7}{t9}{t10}</div>;
    $[23] = t10;
    $[24] = t4;
    $[25] = t7;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}
function _temp() {}